/**
 * Price Range Slider for Dawn Theme
 * Integrates with existing price-range web component and facets form
 * File: assets/price-range-slider.js
 */

(function () {
  'use strict';

  function initPriceSlider(container) {
    const priceRange = container.querySelector('price-range.facets__price');
    const sliderContainer = container.querySelector('.price_progress_slider');

    if (!priceRange || !sliderContainer) return;
    // Avoid double-init
    if (sliderContainer.dataset.initialized) return;
    sliderContainer.dataset.initialized = 'true';

    const minInput = priceRange.querySelector(
      'input[id$="-GTE"], input[name*="filter.p.m.price.gte"], input[name*="price_range"][id*="GTE"]'
    ) || priceRange.querySelectorAll('input[type="number"]')[0];

    const maxInput = priceRange.querySelector(
      'input[id$="-LTE"], input[name*="filter.p.m.price.lte"], input[name*="price_range"][id*="LTE"]'
    ) || priceRange.querySelectorAll('input[type="number"]')[1];

    if (!minInput || !maxInput) return;

    const rangeMin = parseFloat(minInput.min) || 0;
    const rangeMax = parseFloat(minInput.max) || parseFloat(maxInput.max) || 300;

    // Build slider HTML
    sliderContainer.innerHTML = `
      <div class="price-slider__track-wrapper">
        <div class="price-slider__track">
          <div class="price-slider__range"></div>
        </div>
        <input
          type="range"
          class="price-slider__thumb price-slider__thumb--min"
          min="${rangeMin}"
          max="${rangeMax}"
          step="1"
          value="${rangeMin}"
          aria-label="Minimum price"
        />
        <input
          type="range"
          class="price-slider__thumb price-slider__thumb--max"
          min="${rangeMin}"
          max="${rangeMax}"
          step="1"
          value="${rangeMax}"
          aria-label="Maximum price"
        />
      </div>
    `;

    const thumbMin = sliderContainer.querySelector('.price-slider__thumb--min');
    const thumbMax = sliderContainer.querySelector('.price-slider__thumb--max');
    const rangeHighlight = sliderContainer.querySelector('.price-slider__range');

    // Set initial values from existing inputs
    function getInputVal(input) {
      const v = parseFloat(input.value);
      return isNaN(v) ? null : v;
    }

    const initMin = getInputVal(minInput);
    const initMax = getInputVal(maxInput);

    if (initMin !== null) thumbMin.value = initMin;
    if (initMax !== null) thumbMax.value = initMax;

    function updateHighlight() {
      const min = parseFloat(thumbMin.value);
      const max = parseFloat(thumbMax.value);
      const total = rangeMax - rangeMin;
      const leftPct = ((min - rangeMin) / total) * 100;
      const rightPct = ((rangeMax - max) / total) * 100;
      rangeHighlight.style.left = leftPct + '%';
      rangeHighlight.style.right = rightPct + '%';
    }

    function syncToInputs() {
      let min = parseFloat(thumbMin.value);
      let max = parseFloat(thumbMax.value);

      // Prevent handles crossing
      if (min > max - 1) {
        min = max - 1;
        thumbMin.value = min;
      }

      updateHighlight();

      // Update the text inputs and fire native change/input events
      // so Dawn's price-range component picks up the new values
      if (min === rangeMin) {
        minInput.value = '';
      } else {
        minInput.value = min;
      }
      if (max === rangeMax) {
        maxInput.value = '';
      } else {
        maxInput.value = max;
      }

      minInput.dispatchEvent(new Event('change', { bubbles: true }));
      maxInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function syncFromInputs() {
      const min = getInputVal(minInput);
      const max = getInputVal(maxInput);
      if (min !== null) thumbMin.value = Math.max(rangeMin, Math.min(min, rangeMax));
      if (max !== null) thumbMax.value = Math.min(rangeMax, Math.max(max, rangeMin));
      updateHighlight();
    }

    thumbMin.addEventListener('input', syncToInputs);
    thumbMax.addEventListener('input', syncToInputs);

    // Keep slider in sync when user types directly into price inputs
    minInput.addEventListener('input', syncFromInputs);
    maxInput.addEventListener('input', syncFromInputs);
    minInput.addEventListener('change', syncFromInputs);
    maxInput.addEventListener('change', syncFromInputs);

    // Initial highlight
    updateHighlight();
  }

  function initAllSliders() {
    // Desktop horizontal/vertical price filter containers
    document.querySelectorAll('.facets__display, .facets__display-vertical').forEach(function (container) {
      initPriceSlider(container);
    });

    // Mobile drawer containers
    document.querySelectorAll('.mobile-facets__submenu').forEach(function (container) {
      initPriceSlider(container);
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }

  // Re-init after Shopify section renders / AJAX filter updates
  document.addEventListener('shopify:section:load', initAllSliders);

  // Dawn theme re-renders facets via custom events — watch for DOM mutations
  // on the facets container so sliders survive filter AJAX refreshes
  const observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        initAllSliders();
        break;
      }
    }
  });

  function attachObserver() {
    const target = document.querySelector('#FacetsWrapperDesktop, .facets-container, .mobile-facets__main');
    if (target) {
      observer.observe(target, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObserver);
  } else {
    attachObserver();
  }
})();
